import { render, staticRenderFns } from "./currency-picker.vue?vue&type=template&id=180f297e&"
import script from "./currency-picker.vue?vue&type=script&lang=js&"
export * from "./currency-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports